import _Common from "../playmore/common"

class Common extends _Common {
  constructor() {
    super()
  }
  _init = async () => {
    return super._init()
  }

  setTvWindowSize = async position => {
    return super.setTvWindowSize(position)
  }
}

export default Common
